import { Persona } from "@fluentui/react-components";
import { InputWithLabelWrapper, TicketInfoLabel } from "../TicketInfoField/TicketInfoField.styled";
import { useId } from "react";

interface OwnerFieldProps {
    owner: string;
}

export const OwnerField = ({owner}: OwnerFieldProps) => {
    const inputId = useId();

    return (
        <InputWithLabelWrapper>
            <TicketInfoLabel htmlFor={inputId} size="medium">Owner</TicketInfoLabel>
            <Persona textAlignment="center" name={owner} />       
        </InputWithLabelWrapper>
    );
}